var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Dialog, DialogActions, Typography, Backdrop, TextField } from '@mui/material';
export function ModalInputBase(_a) {
    var open = _a.open, onClose = _a.onClose, onConfirm = _a.onConfirm, isSubmitting = _a.isSubmitting, title = _a.title, titleColor = _a.titleColor, message = _a.message, labelInput = _a.labelInput, placeholderInput = _a.placeholderInput, valueInput = _a.valueInput, onChangeInput = _a.onChangeInput, _b = _a.errorInput, errorInput = _b === void 0 ? false : _b, helperText = _a.helperText, onHelperTextProps = _a.onHelperTextProps, confirmText = _a.confirmText, confirmColor = _a.confirmColor, confirmHoverColor = _a.confirmHoverColor, icon = _a.icon;
    return (_jsxs(Dialog, __assign({ open: open, onClose: onClose, fullWidth: true, closeAfterTransition: true, slots: { backdrop: Backdrop }, slotProps: {
            backdrop: {
                timeout: 500,
                sx: { backgroundColor: 'rgba(0, 0, 0, 0.6)' },
            },
        }, PaperProps: {
            sx: { borderRadius: 2, m: 2 },
        } }, { children: [_jsxs(Box, __assign({ sx: { p: 3, pb: 2 } }, { children: [_jsx(Typography, __assign({ variant: 'h6', sx: { color: titleColor, fontWeight: 700, mb: 1 } }, { children: title })), _jsx(Typography, __assign({ variant: 'body2', sx: { color: '#6B7280', mb: 3 } }, { children: message })), _jsx(Typography, __assign({ variant: 'caption', sx: { fontWeight: 600, color: '#374151', mb: 0.5, display: 'block' } }, { children: labelInput })), _jsx(TextField, { fullWidth: true, multiline: true, rows: 3, placeholder: placeholderInput, value: valueInput, error: errorInput, helperText: helperText, onChange: function (e) { return onChangeInput(e.target.value); }, FormHelperTextProps: onHelperTextProps, InputProps: {
                            sx: { fontSize: '0.875rem' },
                        } })] })), _jsxs(DialogActions, __assign({ sx: {
                    p: 2,
                    px: 3,
                    backgroundColor: '#F9FAFB',
                    borderTop: '1px solid #E5E7EB',
                    display: 'flex',
                    justifyContent: 'space-between',
                } }, { children: [_jsx(Button, __assign({ onClick: onClose, variant: 'outlined', disabled: isSubmitting, sx: {
                            color: '#4B5563',
                            borderColor: '#D1D5DB',
                            fontWeight: 600,
                            textTransform: 'none',
                            backgroundColor: '#FFFFFF',
                            '&:hover': { backgroundColor: '#F3F4F6', borderColor: '#D1D5DB' },
                        } }, { children: "CANCELAR" })), _jsx(Button, __assign({ onClick: onConfirm, variant: 'contained', disabled: isSubmitting, disableElevation: true, startIcon: isSubmitting ? _jsx(CircularProgress, { size: 16, color: 'inherit' }) : icon, sx: {
                            backgroundColor: confirmColor,
                            color: 'white',
                            fontWeight: 600,
                            textTransform: 'none',
                            '&:hover': { backgroundColor: confirmHoverColor },
                        } }, { children: isSubmitting ? 'SALVANDO...' : confirmText }))] }))] })));
}
